import React from 'react';

export default function Card({ variant, children }) {
  return (
    <div className={`docpro_card ${variant ? variant : ''}`}>{children}</div>
  );
}
